import React from 'react';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Box, IconButton, Paper } from '@mui/material';
import { SIDEBAR_CONFIG } from '@core/constants/config';
import { useAppLayout } from '@core/contexts/LayoutContext';
import LayoutAppBar from './LayoutAppBar';
import LayoutMainContent from './LayoutMainContent';
import Sidebar from './Sidebar';

const MobileLayout: React.FC = () => {
  const {
    theme,
    sidebarOpen,
    toggleSidebar,
    visibleNavItems,
    routeConfig,
    userAccount,
  } = useAppLayout();

  const logoHeight = SIDEBAR_CONFIG.LOGO_HEIGHT;

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      <Sidebar
        open={sidebarOpen}
        onToggle={toggleSidebar}
        navItems={visibleNavItems}
        logoHeight={logoHeight}
        showLogo={true}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          maxHeight: '100vh',
          minWidth: 0,
          maxWidth: '100%',
          position: 'relative',
          zIndex: 1000,
          marginLeft: 0,
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <LayoutAppBar
          logoHeight={logoHeight}
          userAccount={userAccount}
          startAdornment={
            <IconButton
              onClick={toggleSidebar}
              sx={{
                color: 'text.secondary',
              }}
            >
              <MenuIcon />
            </IconButton>
          }
        />

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            p: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 0,
              p: 2,
              pt: 2,
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              '--Paper-shadow': 'none',
            }}
          >
            <LayoutMainContent routeConfig={routeConfig} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileLayout;
